import(/* webpackMode: "eager" */ "/app/src/app/posts/create/[location]/[category]/page.tsx");
